// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__Q0ssV","unreadBadge":"styles_unreadBadge__1o73H","modalContent":"styles_modalContent__NzsEW","modal":"styles_modal__EM2o6"};